import { format, isValid, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'

export default function formatAnalysesReviewDate(value: string): string {
  const isoLike = value.includes('T') ? value : value.replace(' ', 'T')
  const parsed = parseISO(isoLike)

  if (!isValid(parsed)) {
    return ''
  }

  return format(parsed, 'd MMMM yyyy', { locale: ru })
}
